import Cart from "./Cart";
import StoreUser from "./StoreUser";
import NullProduct from "./NullProduct";
import NullStoreUser from "./NullStoreUser";
import { getUserByEMail, postUsers, users } from "../services/usersService";
import { loadCatalog, postCatalog } from "../services/catalogService";
var Store = /** @class */ (function () {
    function Store() {
        this._user = new NullStoreUser();
        this._catalog = [];
        this._cart = new Cart();
        this.loadCatalog();
    }
    Object.defineProperty(Store.prototype, "user", {
        //Loged user
        get: function () {
            return this._user;
        },
        set: function (user) {
            this._user = user;
            localStorage.setItem("user", JSON.stringify(this._user));
        },
        enumerable: false,
        configurable: true
    });
    Store.prototype.registerUser = function (user) {
        if (getUserByEMail(user.mailAdress)) {
            throw new Error("El usuario que está intentando crear ya existe.");
        }
        else {
            this._user = user;
            localStorage.setItem("user", JSON.stringify(this._user));
            users.push(this._user);
            postUsers();
        }
    };
    Store.prototype.getLogedUser = function () {
        var loadData = localStorage.getItem("user");
        if (loadData) {
            var user = new StoreUser();
            user.create(JSON.parse(loadData));
            this._user = user;
        }
        else {
            this._user = new NullStoreUser();
        }
    };
    Store.prototype.clearUser = function () {
        this._user = new NullStoreUser();
        localStorage.removeItem("user");
    };
    Store.prototype.saveUser = function () {
        localStorage.setItem("user", JSON.stringify(this._user));
        postUsers();
    };
    //Catalog
    Store.prototype.loadCatalog = function () {
        this._catalog = loadCatalog();
    };
    Store.prototype.showCatalog = function () {
        return this._catalog;
    };
    Store.prototype.filterCatalog = function (text) {
        var filteredProducts = this._catalog.filter(function (product) {
            return product.name.toLowerCase().includes(text.trim().toLowerCase()) ||
                product.type.toLowerCase().includes(text.trim().toLowerCase());
        });
        return filteredProducts;
    };
    //Products
    Store.prototype.newProduct = function (prod) {
        this._catalog.push(prod);
        postCatalog(this._catalog);
    };
    Store.prototype.getProductById = function (id) {
        var product = this.showCatalog().filter(function (prod) { return prod.id == id; })[0];
        id && product ? product : (product = new NullProduct());
        return product;
    };
    Store.prototype.editProduct = function () {
        postCatalog(this._catalog);
    };
    Store.prototype.removeProduct = function (id) {
        var productIndex = this._catalog.findIndex(function (p) { return p.id == id; });
        productIndex != -1 ? this._catalog.splice(productIndex, 1) : null;
        postCatalog(this._catalog);
    };
    Object.defineProperty(Store.prototype, "cart", {
        //Cart
        get: function () {
            return this._cart;
        },
        enumerable: false,
        configurable: true
    });
    return Store;
}());
export default Store;
